import IdentityProviderManagementComponent from 'components/desktop/StandingData/IdentityProvider/Management/IdentityProviderManagementComponent';

const IdentityProviderArchiveContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<IdentityProviderManagementComponent archive={true} />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default IdentityProviderArchiveContainer;
